import {PERM} from "../utilites/permissions";
import WorkerTable from "../components/Workers/WorkerTable";
import Worker from "../components/Workers/Worker";

const workers = [
  {
    path: '/workers',
    name: 'Workers',
    component: WorkerTable,
    meta: {requiresAuth: true,
      permissions: [
        PERM.WORKER,
        PERM.WORKER_READ,
      ]
    },
    props: true,
  },
  {
    path: '/workers/new',
    name: 'WorkerAdd',
    component: Worker,
    meta: {requiresAuth: true,
      permissions: [
        PERM.WORKER,
        PERM.WORKER_EDIT,
      ]
    },
    props: true
  },
  {
    path: '/workers/edit/:worker_id',
    name: 'WorkersEdit',
    component: Worker,
    meta: {requiresAuth: true,
      permissions: [
        PERM.WORKER,
        PERM.WORKER_EDIT,
      ]
    },
    props: true
  },
  {
    path: '/workers/view/:worker_id',
    name: 'WorkersView',
    component: Worker,
    meta: {requiresAuth: true,
      permissions: [
        PERM.WORKER,
        PERM.WORKER_READ,
      ]
    },
    props: true
  },
];

export default workers;



// WEBPACK FOOTER //
// ./src/router/workers.js